import { call, takeLatest, put } from 'redux-saga/effects';
import {
    GET_SUPPORTED_LANGUAGES,
    saveSupportedLanguages
} from './actions';
import { api } from '../../utils/api';
import { baseURL } from '../../utils/config'
import { setLoaderVisibility } from '../../shared/ActivityLoader/actions';
import { handleError } from '../../utils/helper';

function* fetchSupportedLanguages() {
    try {
        yield put(setLoaderVisibility(true));
        const response = yield call(api, {
            method: 'GET',
            url: baseURL + 'client/language'
        });
        yield put(setLoaderVisibility(false));
        yield put(saveSupportedLanguages(response.data));
    } catch ({ response: { data } }) {
        handleError(data)
        yield put(setLoaderVisibility(false));
        yield put(saveSupportedLanguages([]));
    }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* watchLanguageSaga() {
    yield takeLatest(GET_SUPPORTED_LANGUAGES, fetchSupportedLanguages)

}